import React from "react";
import styles from "./smarthomereceipt.module.scss";
import downloadIcon from "../../assets/downloadIcon.svg";
import logo from "../../assets/HomeBuddy_RequestedColour_PrimaryLockup.svg";
import check from "../../assets/check.svg";

type ReceiptDetail = {
  label: string;
  value?: string;
  meta?: {
    first?: string;
    second?: string;
  };
};

const SmartHomesReceipt = () => {
  const receiptDetails: ReceiptDetail[] = [
    {
      label: "Sender Details",
      value: "Adesewa Owoeye",
      meta: {
        first: "Access",
        second: "0987654312",
      },
    },
    {
      label: "Recipient's Details",
      value: "Homebuddy",
      meta: {
        first: "Paystack",
        second: "7432054312",
      },
    },
    {
      label: "Amount",
      value: "NGN 650,000",
    },
    {
      label: "Purpose of Payment",
      value: "Smart Home Installment",
    },
    {
      label: "Date",
      value: "November 2, 2024",
    },
  ];
  return (
    <div className={styles["super-container"]}>
      <div className={styles["but-receipt"]}>
        <div className={styles["download-but"]} role="button">
          <span className={styles["but-text"]}>Download Receipt</span>
          <img src={downloadIcon} />
        </div>

        <div className={styles.receipt}>
          <div className={styles.logo}>
            <img src={logo} />
          </div>
          <div className={styles["success-div"]}>
            <div className={styles.check}>
              <img src={check} /> 
            </div>
            <span className={styles["check-text"]}>Payment Successful</span>
          </div>

          <span className={styles["amt-text"]}>Transaction Amount</span>
          <span className={styles["amt-bold-text"]}>{"NGN 650,000"}</span>

          <div className={styles.details}>
            {receiptDetails.map((detail, index) => (
              <div className={styles["each-detail"]} key={index}>
                <div className={styles.dash}></div>
                <div className={styles["detail-text"]}>
                  <span className={styles["label-txt"]}>{detail?.label}</span>
                  <span className={styles["value-txt"]}>{detail?.value}</span>
                </div>
                {detail?.meta ? (
                  <div className={styles["meta-div"]}>
                    <span className={styles["meta-txt"]}>
                      {detail?.meta?.first}
                    </span>
                    <div className={styles["meta-dash"]}></div>
                    <span className={styles["meta-txt"]}>
                      {detail?.meta?.second}
                    </span>
                  </div>
                ) : null}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmartHomesReceipt;
